import {
  AgencyConsortia,
  AgencyConsortiaPayload,
  GetAgencyConsortiaActionOutput,
  GetCruiseLinesActionInput,
  GetCruiseLinesActionOutput,
  GetHostAgenciesActionOutput,
  HostAgency,
  HostAgencyPayload,
  ICruiseLine,
  UpsertAgencyConsortiaActionOutput,
  UpsertHostAgencyActionOutput,
} from "@cruisen/contract"
import { callFirebaseFunction } from "../callFirebaseFunction"
import { _t } from "@cruisen/i18n"

export const getCruiseLines = async (input?: GetCruiseLinesActionInput): Promise<ICruiseLine[]> => {
  const result = await callFirebaseFunction({
    name: "dictionariesAction",
    payload: {
      action: "getCruiseLines",
      ...(input ?? {}),
    },
  })

  if (result.error) {
    alert(`${_t("errors.cruiseLines")} ${_t("errors.tryAgainLater")}`)
    return []
  }

  return (result.data as GetCruiseLinesActionOutput).result
}

export const getAgencyConsortia = async (): Promise<AgencyConsortia[]> => {
  const result = await callFirebaseFunction({
    name: "dictionariesAction",
    payload: {
      action: "getAgencyConsortia",
    },
  })

  if (result.error) {
    alert(`${_t("errors.agencyConsortia")} ${_t("errors.tryAgainLater")}`)
    return undefined
  }

  return (result.data as GetAgencyConsortiaActionOutput).result
}

export const upsertAgencyConsortia = async (
  consortia: AgencyConsortiaPayload,
): Promise<AgencyConsortia> => {
  const result = await callFirebaseFunction({
    name: "dictionariesAction",
    payload: {
      action: "upsertAgencyConsortia",
      consortia,
    },
  })

  if (result.error) {
    alert(`${_t("errors.agencyConsortia")} ${_t("errors.tryAgainLater")}`)
    return undefined
  }

  return (result.data as UpsertAgencyConsortiaActionOutput).result
}

export const getHostAgencies = async (): Promise<HostAgency[]> => {
  const result = await callFirebaseFunction({
    name: "dictionariesAction",
    payload: {
      action: "getHostAgencies",
    },
  })

  if (result.error) {
    alert(`${_t("errors.hostAgency")} ${_t("errors.tryAgainLater")}`)
    return undefined
  }

  return (result.data as GetHostAgenciesActionOutput).result
}

export const upsertHostAgency = async (agency: HostAgencyPayload): Promise<HostAgency> => {
  const result = await callFirebaseFunction({
    name: "dictionariesAction",
    payload: {
      action: "upsertHostAgency",
      agency,
    },
  })

  if (result.error) {
    alert(`${_t("errors.hostAgency")} ${_t("errors.tryAgainLater")}`)
    return undefined
  }

  return (result.data as UpsertHostAgencyActionOutput).result
}
